import React from 'react';
import './common.css';

const Button = ({ children, onClick, type = 'button', variant = 'primary', className = '', disabled = false }) => {
  // Use CSS classes from common.css instead of inline Tailwind
  const buttonClass = `neon-btn neon-btn-${variant} ${className} ${disabled ? 'disabled' : ''}`;
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={buttonClass}
    >
      <span className="btn-content">{children}</span>
      <span className="neon-btn-glow"></span>
    </button>
  );
};

export default Button;